// Vendors
import $ from 'jquery';

$(window).scroll(function () {
  const header = $('.site-header'),
    scroll = $(window).scrollTop();

  if (scroll >= 185) {
    header.addClass('fixed-position');
    setTimeout(function () {
      header.addClass('sticky-transition');
    }, 100);
  } else {
    header.removeClass('sticky-transition');
    header.removeClass('fixed-position');
  }
  if ($('body.home').length) {
    if (scroll >= 860) {
      header.addClass('sticky');
    } else {
      header.removeClass('sticky');
    }
  } else {
    if (scroll >= 690) {
      header.addClass('sticky');
    } else {
      header.removeClass('sticky');
    }
  }
});
